$(document).ready(function(){
    $('.footer-powered').remove()
})